module.exports = __webpack_public_path__ + "static/media/Spinner-0.9s-200px.1fbdf0cc.svg";